import React from "react";

const extractPersonalInfoFromId = (id_no) => {
  if (!id_no || id_no.length !== 12)
    return { dob: "N/A", gender: "N/A", age: "N/A" };

  const year = id_no.substring(0, 2);
  const month = id_no.substring(2, 4);
  const day = id_no.substring(4, 6);
  const genderDigit = parseInt(id_no.substring(11, 12), 10);

  const birthYear =
    parseInt(year, 10) > new Date().getFullYear() % 100
      ? `19${year}`
      : `20${year}`;
  const dob = new Date(`${birthYear}-${month}-${day}`);
  const gender = genderDigit % 2 === 0 ? "Female" : "Male";

  const calculateAge = (dob) => {
    const today = new Date();
    let age = today.getFullYear() - dob.getFullYear();
    const monthDifference = today.getMonth() - dob.getMonth();
    if (
      monthDifference < 0 ||
      (monthDifference === 0 && today.getDate() < dob.getDate())
    ) {
      age--;
    }
    return age;
  };

  const age = calculateAge(dob);

  return { dob: dob.toDateString(), gender, age };
};

const InsuredPersonalInfo = ({ data }) => {
  const insuranceType = data?.order_details?.insurance_type;
  let personalInfo = {};

  switch (insuranceType) {
    case 1:
      personalInfo = data.foreign_worker_insurance || {};
      break;
    case 2:
      personalInfo = data.term_life_insurance || {};
      break;
    case 3:
      personalInfo = data.health_insurance || {};
      break;
    case 4:
      personalInfo = data.pa_insurance || {};
      break;
    case 5:
      personalInfo = data.motor_insurance || {};
      break;
    case 6:
      personalInfo = data.offshore_insurance || {};
      break;
    case 7:
      personalInfo = data.group_insurance || {};
      break;
    case 8:
      personalInfo = data.property_insurance || {};
      break;
    default:
      personalInfo = {};
  }

  const {
    user_id,
    enquirer_name,
    id_type,
    id_no,
    occupation,
    is_smoker,
    email: personalEmail,
    is_manual_work,
    weekly_indemnity,
    sum_insured,
  } = personalInfo;

  const fullName = data?.order_details?.full_name || enquirer_name;
  const phone_number = data?.order_details?.mobile_number;
  const orderOccupation = data?.order_details?.occupation;

  const { dob, gender, age } = extractPersonalInfoFromId(id_no);

  const email = personalEmail || data.email;

  return (
    <div className="row">
      <div className="col-md-4 mb-3">
        <label className="form-label">User ID:</label>
        <p>
          <b>{user_id || "N/A"}</b>
        </p>
      </div>
      <div className="col-md-4 mb-3">
        <label className="form-label">Insured's Full Name:</label>
        <p>
          <b>{fullName || "N/A"}</b>
        </p>
      </div>
      <div className="col-md-4 mb-3">
        <label className="form-label">ID Type:</label>
        <p>
          <b>{id_type || "N/A"}</b>
        </p>
      </div>
      <div className="col-md-4 mb-3">
        <label className="form-label">ID No:</label>
        <p>
          <b>{id_no || "N/A"}</b>
        </p>
      </div>
      <div className="col-md-4 mb-3">
        <label className="form-label">Age:</label>
        <p>
          <b>{age}</b>
        </p>
      </div>
      <div className="col-md-4 mb-3">
        <label className="form-label">Date of Birth (DOB):</label>
        <p>
          <b>
            {new Date(dob)
              .toLocaleDateString("en-GB", {
                day: "2-digit",
                month: "short",
                year: "numeric",
              })
              .replace(/ /g, "-")}
          </b>
        </p>
      </div>
      <div className="col-md-4 mb-3">
        <label className="form-label">Gender:</label>
        <p>
          <b>{gender}</b>
        </p>
      </div>
      {insuranceType === 4 && (
        <>
          <div className="col-md-4 mb-3">
            <label className="form-label">Occupation:</label>
            <p>
              <b>{orderOccupation || "N/A"}</b>
            </p>
          </div>
          <div className="col-md-4 mb-3">
            <label className="form-label">Job Involve Manual Work:</label>
            <p>
              <b>{is_manual_work ? "Yes" : "No"}</b>
            </p>
          </div>
          <div className="col-md-4 mb-3">
            <label className="form-label">Weekly Indemnity:</label>
            <p>
              <b>{weekly_indemnity || "N/A"}</b>
            </p>
          </div>
        </>
      )}
      {insuranceType !== 5 && (
        <div className="col-md-4 mb-3">
          <label className="form-label">Smoker/Non-Smoker:</label>
          <p>
            <b>{is_smoker ? "Smoker" : "Non-Smoker"}</b>
          </p>
        </div>
      )}
      <div className="col-md-4 mb-3">
        <label className="form-label">Sum Insured:</label>
        <p>
          <b>{sum_insured || "N/A"}</b>
        </p>
      </div>
      <div className="col-md-4 mb-3">
        <label className="form-label">Email Address:</label>
        <p>
          <b>{email || "N/A"}</b>
        </p>
      </div>
      <div className="col-md-4 mb-3">
        <label className="form-label">Phone Number:</label>
        <p>
          <b>{phone_number || "N/A"}</b>
        </p>
      </div>
    </div>
  );
};

export default InsuredPersonalInfo;
